import { useEffect, useState } from 'react'

const useWidth = () => {    

    const getWindowDimensions = () => {
        const { innerWidth: width, innerHeight: height } = window
        return {
            width,
            height
        };
    }

    useEffect(() => {
        const handleResize = () => {
            setWindowDimensions(getWindowDimensions())
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

    return { windowDimensions }
}

export default useWidth
